module.exports.stats = {
  vi: {
    title: 'Avalon: The Resistance | Thống kê',
    description: 'Thống kê các ván The Resistance: Avalon trực tuyến.',
    keywords: ['Thống kê', 'Số liệu', 'Tỷ lệ thắng'],
  },
  pt: {
    title: 'Avalon: The Resistance | Estatísticas',
    description: "Estatísticas para jogos online em 'Avalon: The Resistance'",
    keywords: ['Estatísticas', 'Dados', 'Taxa de vitória'],
  },
  en: {
    title: 'Avalon: The Resistance | Statistics',
    description: "Statistics for online games in 'Avalon: The Resistance'",
    keywords: ['Statistics', 'Stats', 'Winrate'],
  },
  ru: {
    title: 'Авалон: Сопротивление | Статистика',
    description: "Статистика для онлайн игр в 'Авалон: Сопротивление'",
    keywords: ['Статистика', 'Показатели', 'Процент побед'],
  },
  'zh-TW': {
    title: '阿瓦隆：反抗勢力 | 統計',
    description: '『阿瓦隆：反抗勢力』在線遊戲的統計數據',
    keywords: ['統計', '數據', '勝率'],
  },
  'zh-CN': {
    title: '阿瓦隆：反抗组织 | 统计',
    description: '《阿瓦隆：反抗组织》在线游戏的统计数据',
    keywords: ['统计', '数据', '胜率'],
  },
  es: {
    title: 'Avalon: La Resistencia | Estadísticas',
    description: "Estadísticas para juegos en línea en 'Avalon: La Resistencia'",
    keywords: ['Estadísticas', 'Datos', 'Porcentaje de victorias'],
  },
};
